import React, { useState } from 'react';
import logo from './assets/usku_logo.png';

import { db } from './Firebase/firebase';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
    },
}));

function OrderStatus() {

    const classes = useStyles();

    const [error, setError] = useState(null);
    const [pin, setPin] = useState("");
    const [orderStatus, setOrderStatus] = useState(null); // the status

    function checkOrder(e) {
        e.preventDefault();
        e.persist();

        // reset status to null
        setError(null);
        setOrderStatus("Retrieving...");

        // validate input field
        if (pin === "") {
            setError("Please enter the reference number");
            setOrderStatus(null);
            return
        }

        // processing start
        try {
            db.collection('TEST_ORDERS').doc(pin)
                .get()
                .then((doc) => {
                    if (doc.exists) {
                        const data = doc.data();

                        let status = "";
                        if (data.status === "available") {
                            status = "Order has been received";
                        } else if (data.status === "accepted") {
                            status = "Item is being picked up";
                        } else if (data.status === "completed") {
                            status = "Item is on the way for delivery";
                        }

                        setOrderStatus(status);
                    } else {
                        setError("Order not exist. Please enter a valid reference number");
                        setOrderStatus(null);
                    }
                })
        } catch (err) {
            setError(err.message);
            setOrderStatus(null);
        }
    }

    return (
        <div>
            <div className="form">
                <div className="form-container">
                    <img className="usku-logo" src={logo} alt="Usku" />
                    <h1>Track Your Orders</h1>
                    <br/>
                    <form id="material-form" className={classes.root} noValidate autoComplete="off" style={{width: "40%"}}>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <TextField id="outlined-basic" label="Order Reference Number" onChange={(e) => setPin(e.target.value)} variant="outlined" name="pin" value={pin} fullWidth={true} />
                            </Grid>
                        </Grid>
                    </form>
                    <br/>
                    {error === null ? <p></p> : <p style={{textAlign: "center", color: "red"}}>{error}</p>}
                    {orderStatus === null ? <p></p> : <h4 style={{textAlign: "center"}}>{orderStatus}</h4>}
                    <div style={{textAlign: "center"}}>
                        <Button style={{backgroundColor: "orange", color: "black"}} onClick={checkOrder} >Check Order Status</Button>
                    </div>
                    <br/>
                </div>
            </div>
        </div>
    )
}

export default OrderStatus;